import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import { PageResultDto } from '../../../common/viewModels/GlobalRegistry/UnitsModel';
import { LabModel } from '../../../common/viewModels/Admin/LabModel';
import { CustomerModel } from '../../../common/viewModels/Admin/CustomerModel';
import { JobCardModel } from '../../../common/viewModels/Analysis/SampleModel';
import { FormatService } from '../../../common/formatService';
import { AmplifyService } from '../../../common/amplify-service';
import 'rxjs/add/operator/map'

@Component({
    selector: 'jobcardlist',
    templateUrl: './jobcardlist.component.html',
    styleUrls: ['./jobcardlist.component.scss']
})
export class JobCardList implements OnInit {

    id: number;
    jobCardSearchForm: FormGroup;
    labs: LabModel;
    searchFields: JobCardModel = new JobCardModel();
    customers: CustomerModel;
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    pageResult: PageResultDto;
    length: number = 0;
    mainComponent: any;
    pageSize: number = 10;
    isShowSelectOption: boolean = true;

    constructor(public _router: Router, private _formBuilder: FormBuilder, private _formatService: FormatService,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _validationService: ValidationService, private _mApp: MainAppComponent, private _pageSrvc: PagerService,
        private _toastrService: ToastrService, private _amplifyService: AmplifyService) {
        this.mainComponent = _mApp;
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
        this.GetLabs();
        this.GetCustomers();
        this.CreateSearchForm();
        if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
            this.jobCardSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.DefaultCompanyId) {
            this.jobCardSearchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
        }
        if(curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3){
            this.isShowSelectOption = false;
        }
        this.GetDataFromAmpliy();
        // Call ConstructSearchData AFTER all defaults are set
        this.ConstructSearchData();
        this.setPage(this.pager);
        this.ClearDataInAmplify();
    }

    CreateSearchForm() {
        this.jobCardSearchForm = this._formBuilder.group({
            CustomerId: [''],
            JobCardNumber: [''],
            LabIds: [''],
            ReceivedFrom: [null],
            ReceivedTo: [null]
        })

    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetJobCardList(this.pager);
    }

    GetLabs() {
        this._http.get(this._appUrl.GetLabsMinInfoList)
            .subscribe(
                data => {
                   if(this._mApp.userTypeId == 2) {
                        let lstLabs = data.json().Result;
                        if (this._mApp.currentUserLabIds && lstLabs)
                        lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
                        this.labs = lstLabs;
                    }
                    else {
                        this.labs = data.json().Result;
                    }
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.customers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    };
    onSubmit() {
        this.pager.pageIndex = 0;
        this.ConstructSearchData();

        this.setPage(this.pager);
    }

    OnReset() {
        this.jobCardSearchForm.reset();
        this.CreateSearchForm();
        this.searchFields.CustomerId = this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0;
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.searchFields.JobCardNumber = '';
        this.searchFields.LabIds = [];
        this.searchFields.JobCardId = 0;
        this.searchFields.ReceivedFrom = '';
        this.searchFields.ReceivedTo = '';
        // this.GetLabs();
        this.GetCustomers();
        this.jobCardSearchForm.controls['ReceivedFrom'].markAsUntouched();
        this.jobCardSearchForm.controls['ReceivedTo'].markAsUntouched();
        this.jobCardSearchForm.controls['CustomerId'].setValue(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
        this.setPage(this.pager);
        if (this._mApp.userTypeId == 2) {
            var currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
            this.jobCardSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
    }

    ConstructSearchData() {
        let searchDto = this.jobCardSearchForm.value;
        this.searchFields.CustomerId = searchDto.CustomerId;
        this.searchFields.LabIds = searchDto.LabIds;
        this.searchFields.JobCardNumber = searchDto.JobCardNumber;
        this.searchFields.ReceivedFrom = this._formatService.formatDate(searchDto.ReceivedFrom);
        this.searchFields.ReceivedTo = this._formatService.formatDate(searchDto.ReceivedTo);
    }

    GetJobCardList(page: any) {
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetListOfJobCard, this.searchFields)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    var response = data.json();
                    this.length = response.PageResult.TotalRecords;
                    this.pagedItems = response.Result;
                    this.isNoRecords = !(response.Result.length > 0)
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, "")
                }
            )
    }

    EditJobCard(jobCardId) {
        this.SaveDataInAmplify();
        this._router.navigate(['/addeditjobcard', jobCardId]);
    }

    DeleteJobCard(id: any) {
        this.id = id;
    }

    SaveDataInAmplify() {
        this._amplifyService.SetStorage('jobCardList', this.jobCardSearchForm.value);
        this._amplifyService.SetStorage('jobCardList_PageNo', this.pager.pageIndex);
        this._amplifyService.SetStorage('jobCardList_PageSize', this.pager.pageSize);
    }


    GetDataFromAmpliy() {
        let storedData = this._amplifyService.GetStorage('jobCardList');
        if (storedData != undefined && storedData != null) {
            this.jobCardSearchForm.setValue(storedData);
        }
        // let savedPageSize = this._amplifyService.GetStorage('jobCardList_PageSize');
        // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pageSrvc.pageSize;
        let pageIndex = this._amplifyService.GetStorage('jobCardList_PageNo');
        if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
            this.pager.pageIndex = pageIndex;
        else
            this.pager.pageIndex = 0;
    }

    ClearDataInAmplify() {
        this._amplifyService.ClearStorage('jobCardList');
        this._amplifyService.ClearStorage('jobCardList_PageNo');
        this._amplifyService.ClearStorage('jobCardList_PageSize');
    }

    DeleteJobCardById(id) {
        this.SaveDataInAmplify();
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteJobCardById + id)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result, "");
                    this.GetDataFromAmpliy();
                    this.setPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, "")
                }
            )
    }

    DownloadJobCardreports(jobCardId) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DownloadJobCardRelatedReports + jobCardId)
            .subscribe(
                data => {

                    this._mApp.HideLoader();
                    var res = data.json().Result;
                    if (res != "" && res != null && res != undefined) {
                        window.open(res, '_blank');
                    }
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    };
}
